import { AHText, AHTextFonts, useTheme } from "arkh";
import React from "react";

export const FollowupMissed = ({
  isOptional,
  style,
}: {
  isOptional?: boolean;
  style?: any;
}) => {
  const theme = useTheme();
  return (
    <AHText
      style={[
        {
          color: isOptional === true ? theme.washedText : theme.negative,
          textAlign: "center",
        },
        style,
      ]}
      font={AHTextFonts.BOLD}
      type="title-small"
    >
      -
    </AHText>
  );
};
